module.exports = __webpack_public_path__ + "static/media/3.ec99aae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/perks/3.png
// module id = 59
// module chunks = 0